<template>
  <div>
    <el-dialog
      top="5vh"
      title="配置执行数据"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @open="open"
      @closed="closed"
    >
      <div v-loading="loading">
        <div class="text-right" v-if="!readonly">
          全选
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          ></el-checkbox>
        </div>
        <div
          v-for="gpFieldGroup in gpFieldGroupNameMap"
          :key="gpFieldGroup.key"
          class="exec-box"
        >
          <p style="font-weight: 600">{{ gpFieldGroup.value }}</p>
          <div
            v-for="item in execDataConfigList"
            :key="item.fieldId"
            :style="{
              'padding-bottom': item.fieldGroup === gpFieldGroup.key ? '20px' : '0px',
              display: item.fieldGroup === gpFieldGroup.key ? 'contents' : 'none',
            }"
          >
            <el-col :span="12" v-if="item.fieldGroup === gpFieldGroup.key">
              <el-col :span="18">
                <div @click="handleChecked(item)" class="exec-item">
                  {{ item.displayName }}
                </div>
              </el-col>
              <el-col :span="4">
                <el-checkbox
                  v-model="item.checked"
                  @change="handleCheckedChange"
                  :disabled="item.disabled || readonly"
                ></el-checkbox>
              </el-col>
            </el-col>
          </div>
        </div>
        <div class="btn_section" v-if="!readonly">
          <el-button class="btn_bg_white normal_btn" @click="dialogVisible = false"
            >取消</el-button
          >
          <el-button class="btn_bg_red normal_btn" @click="submit">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import gameplanApi from "@/api/gameplan";
import baseApi from "@/api/base";
export default {
  components: {},
  props: {
    themeId: {
      type: String,
      default: "",
    },
    execDataConfigedList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      checkAll: false,
      checkedDatas: [],
      isIndeterminate: false,
      execDataConfigList: [],
      gpFieldGroupNameMap: [],
    };
  },
  computed: {},
  methods: {
    // 打开dialog
    handleOpen() {
      this.dialogVisible = true;
    },
    open() {
      this.getGpFieldGroupNameMap();
      this.getExecDataConfig();
    },
    async getExecDataConfig() {
      this.loading = true;
      let params = {
        themeId: this.themeId,
      };
      const { data } = await gameplanApi.getExecDataConfig(params);
      if (data.resultCode === "0") {
        this.execDataConfigList = data.resultData.execDataConfigList || [];
        if (!this.themeId) {
          // 新建
          this.execDataConfigList.map((items) => {
            this.execDataConfigedList.some((item) => {
              if (items.fieldId === item.fieldId) {
                items.checked = item.checked;
              }
            });
          });
        }
        this.handleCheckedChange();
      }
      this.loading = false;
    },
    async getGpFieldGroupNameMap() {
      let params = {
        name: "gpFieldGroupNameMap",
      };
      const { data } = await baseApi.getDictData(params);
      if (data.resultCode === "0") {
        this.gpFieldGroupNameMap = data.resultData.gpFieldGroupNameMap || [];
      }
    },
    // 全选/全不选
    handleCheckAllChange(val) {
      const checkList = [];
      for (let i = 0; i < this.execDataConfigList.length; i++) {
        this.execDataConfigList[i].checked = val;
        checkList.push(this.execDataConfigList[i]);
      }
      this.checkedDatas = val ? checkList : [];
      this.isIndeterminate = false;
    },
    // 监听checkbox变化
    handleCheckedChange() {
      this.checkedDatas = [];
      for (let i = 0; i < this.execDataConfigList.length; i++) {
        if (this.execDataConfigList[i].checked === true) {
          this.checkedDatas.push(this.execDataConfigList[i]);
        }
      }
      this.checkAll = this.checkedDatas.length === this.execDataConfigList.length;
      this.isIndeterminate =
        this.checkedDatas.length > 0 &&
        this.checkedDatas.length < this.execDataConfigList.length;
    },
    // 提交
    async submit() {
      if (this.loading) return;
      if (this.themeId) {
        if(this.checkedDatas.length===0) return this.$message.error("请配置执行数据")
        // 修改
        this.loading = true;
        let params = {
          themeId: this.themeId,
          execDataConfigList: this.checkedDatas,
        };
        const { data } = await gameplanApi.submitExecDataConfigToTheme(params);
        if (data.resultCode === "0") {
          this.dialogVisible = false;
        }
        this.loading = false;
      } else {
        // 新建
        this.$emit("on-submit", this.checkedDatas);
        this.dialogVisible = false;
      }
    },
    handleChecked(item) {
      if(!this.readonly){
        item.checked = !item.checked;
        this.handleCheckedChange();
      }
    },
    // 重置状态
    closed() {
      this.checkAll = false;
      this.checkedDatas = [];
      this.isIndeterminate = false;
      this.execDataConfigList = [];
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  margin: 0 auto 15px;
}
::v-deep .el-dialog__body {
  overflow: auto;
  max-height: 70vh;
}
::v-deep .el-checkbox-group {
  font-size: 14px;
}

::v-deep .el-col {
  margin: 5px 0px;
}
::v-deep .el-checkbox__input {
  margin-top: 0px !important;
}

::v-deep .el-checkbox__label {
  margin-top: 0px !important;
}
::v-deep .is-indeterminate .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

::v-deep .el-checkbox__inner:hover,
::v-deep .el-checkbox__input .el-checkbox__inner:focus {
  border-color: #409eff !important;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .el-checkbox__input.is-focus .el-checkbox__inner:hover {
  border-color: #409eff !important;
}
.exec-box {
  display: inline-block;
  width: 100%;

  + .exec-box {
    border-top: 1px solid #dcdfe6;
  }

  .exec-item {
    cursor: pointer;
    line-height: 16px;
    padding-left: 40px;
  }
}

.btn_section {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  text-align: center;
  margin-top: 60px;

  .normal_btn {
    width: auto;
    // padding: 10px 0;
    border-radius: 5px;
    cursor: pointer;
  }

  .btn_bg_white {
    border: 1px solid rgb(204, 0, 0);
    color: rgb(204, 0, 0);
    // margin-right: 100px;
  }

  .btn_bg_red {
    color: white;
    background-color: rgb(204, 0, 0);
    border: 1px solid rgb(204, 0, 0);
  }
}
</style>
